import { crudReducer } from "./dataHelper";

const initialState = () => ({
  professionals: []
});

const actions = () => ({});

export default crudReducer("professional", initialState, actions);
